import { Component, Ref } from '@angular';

import { InstitutionForm } from '@components/institution-form/institution-form.component';
import { Modal } from '@mixins/modal.component';

@Component({
  name: 'createInstitutionModal',
  template: require('./create-institution.html')
})
export class CreateInstitutionModalController extends Modal {
  submitting = false;

  @Ref readonly institutionForm!: InstitutionForm;

  get processing() {
    return this.submitting || this.institutionForm.processing;
  }

  get canSubmit() {
    return this.institutionForm.isValid;
  }

  get onLastStep() {
    return this.institutionForm.onLastStep;
  }

  get onFirstStep() {
    return this.institutionForm.onFirstStep;
  }

  nextStep() {
    this.institutionForm.stepNext();
  }

  previousStep() {
    this.institutionForm.stepPrevious();
  }

  async submit() {
    let data: any = null;
    let error: Error | null = null;

    this.submitting = true;

    try {
      data = await this.institutionForm.submit();
    } catch (err) {
      error = err;
    }

    this.submitting = false;

    if (error) {
      return this.notify.error(
        `Failed to create the institution: ${error.message}`
      );
    }

    this.notify.success(`Institution created successfully.`);

    this.$close(data);
  }
}

export default CreateInstitutionModalController.$module;
